






























































import { Component, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import DeskDto from '@/models/Desks/DeskDto';
import UpdateDeskExternalPayrollSystemSettingsRequest from '@/models/Desks/UpdateDeskExternalPayrollSystemSettingsRequest';
import ajax from '@/lib/ajax';

@Component({
    name: 'DeskExternalPayrollEdit'
})
export default class extends GiganautVueDialog {

  public entity: DeskDto | null = null;
  public payrollSystemConfigured = false;
  public externalIdValues: string[] = [];
  public loadingExternalIds = false;

  @Watch('dialog')
  onDialogChanged(val: boolean) {
    if (val) {
      // Deep-clone so the dialog can edit without touching the live store row.
      this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.currentDesk));
      this.fetchExternalIdValues();
    }
  }

  // The valid values come from the payroll adapter (PurePro: business unit
  // references). On any failure we fall back to the free-text field rather
  // than blocking the edit.
  async fetchExternalIdValues() {
    this.loadingExternalIds = true;
    this.payrollSystemConfigured = false;
    this.externalIdValues = [];
    try {
      const response = await ajax.get('/api/v1/agency/payroll/desk-external-ids');
      this.payrollSystemConfigured = response.data.configured && response.data.values.length > 0;
      this.externalIdValues = response.data.values;
    } catch (error) {
      // Fall back to free text; the admin can still edit.
    } finally {
      this.loadingExternalIds = false;
    }
  }

  // Include the desk's current value even if the provider no longer lists it,
  // so an existing (stale) assignment still displays instead of looking blank.
  get externalIdItems(): string[] {
    const items = [...this.externalIdValues];
    const current = this.entity ? this.entity.externalPayrollSystemId : '';
    if (current && !items.includes(current)) {
      items.unshift(current);
    }
    return items;
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate() || !this.entity) {
      return;
    }
    const request = new UpdateDeskExternalPayrollSystemSettingsRequest();
    request.updatedAt = this.entity.updatedAt;
    // v-select's clearable emits null — normalise to empty string.
    request.externalPayrollSystemId = this.entity.externalPayrollSystemId || '';
    await AgencySettingsModule.editDeskExternalPayrollSystemSettings(request);
    this.dialog = false;
  }
}
